import { waLink, WHATSAPP_INTENTS } from "../config";

const columns = [
  {
    title: "Keşfet",
    links: [
      { label: "Menü", href: "#menu" },
      { label: "Nasıl Çalışır", href: "#nasil-calisir" },
      { label: "Bölgeler", href: "#bolge" },
      { label: "Fiyatlar", href: "#fiyat" },
    ],
  },
  {
    title: "Kurumsal",
    links: [
      { label: "Hakkımızda", href: "#hikaye" },
      { label: "Belgeler", href: "#guven" },
      { label: "Kurumsal Yemek", href: "#kurumsal" },
      { label: "İletişim", href: "#footer-iletisim" },
    ],
  },
  {
    title: "Yardım",
    links: [
      { label: "SSS", href: "#sss" },
      { label: "Teslimat", href: "#bolge" },
      { label: "WhatsApp", href: waLink(WHATSAPP_INTENTS.hero) },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-primary-500 flex items-center justify-center shrink-0">
                <i className="ri-vip-crown-line text-background-50 text-xl"></i>
              </div>
              <div className="leading-none">
                <span className="block font-heading text-xl font-bold whitespace-nowrap">
                  Meliha Sultan
                </span>
                <span className="block text-[10px] tracking-[0.25em] text-background-50/60 font-semibold whitespace-nowrap">
                  EV YEMEKLERİ
                </span>
              </div>
            </div>
            <p className="mt-5 text-background-50/70 text-sm leading-relaxed max-w-xs">
              Annemizin tarifleri, sizin sofranızda.
            </p>
            <div id="footer-iletisim" className="mt-6 space-y-2 text-sm text-background-50/70">
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>Adres bilgisi eklenecek</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>Telefon bilgisi eklenecek</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>E-posta bilgisi eklenecek</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-verified-badge-line"></i>
                <span>ETBİS bilgisi eklenecek</span>
              </p>
            </div>
          </div>

          {/* Link columns */}
          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base font-bold">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.href.startsWith("http") ? "_blank" : undefined}
                      rel={link.href.startsWith("http") ? "nofollow noopener" : undefined}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Legal placeholder */}
        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            © {new Date().getFullYear()} Meliha Sultan Ev Yemekleri. Tüm hakları saklıdır.
          </p>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {["KVKK", "Gizlilik", "Çerez", "Mesafeli Satış"].map((label) => (
              <a
                key={label}
                href="#"
                className="text-xs text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}